import { render, staticRenderFns } from "./details-page.vue?vue&type=template&id=6ce3e88f&"
import script from "./details-page.vue?vue&type=script&lang=ts&"
export * from "./details-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ce3e88f')) {
      api.createRecord('6ce3e88f', component.options)
    } else {
      api.reload('6ce3e88f', component.options)
    }
    module.hot.accept("./details-page.vue?vue&type=template&id=6ce3e88f&", function () {
      api.rerender('6ce3e88f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/details-page/details-page.vue"
export default component.exports